module.exports = __webpack_public_path__ + "static/cover_uschtrin_weber-136052b8488658163f39aa29aa70179f.jpg";